import { MULTI_SUB_PLAN_PICKER_ENABLED } from 'aa/helpers/featureConstants';

export function currentPlan(store) {
    if (store.featureIsActive(MULTI_SUB_PLAN_PICKER_ENABLED)) {
        return store['plan/getSelectedPlan'];
    } else {
        return store['plan/getCurrentPlan'];
    }
}
